export class RoleResponseEntity {
  createdAt?: string;
  updatedAt?: string;
  id?: string;
  name?: string;
  code?: string;
  description?: string;
  type?: number;
  status?: number;

  constructor(data?: Partial<RoleResponseEntity>) {
    this.createdAt = data?.createdAt;
    this.updatedAt = data?.updatedAt;
    this.id = data?.id;
    this.name = data?.name;
    this.code = data?.code;
    this.description = data?.description;
    this.type = data?.type;
    this.status = data?.status;
  }
}
